import { render, staticRenderFns } from "./CommunicationCard.vue?vue&type=template&id=0178647a&scoped=true"
import script from "./CommunicationCard.vue?vue&type=script&lang=js"
export * from "./CommunicationCard.vue?vue&type=script&lang=js"
import style0 from "./CommunicationCard.vue?vue&type=style&index=0&id=0178647a&prod&lang=css"
import style1 from "./CommunicationCard.vue?vue&type=style&index=1&id=0178647a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0178647a",
  null
  
)

export default component.exports